import { useState, useEffect } from "react";

/**
 * Hook reusable para detectar tipo de dispositivo: mobile o desktop
 */
export const useDeviceType = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [isBrowser, setIsBrowser] = useState(false);

    useEffect(() => {
        const regex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i;

        const mobile = typeof navigator !== "undefined" && regex.test(navigator.userAgent);
        setIsMobile(mobile);
        setIsBrowser(!mobile);
    }, []);

    return { isMobile, isBrowser };
};

/**
 * Hook reusable para detectar orientación del dispositivo
 */
export const useOrientation = () => {
    const [isLandscape, setIsLandscape] = useState(
        typeof window !== "undefined" && window.matchMedia("(orientation: landscape)").matches
    );

    useEffect(() => {
        if (typeof window === "undefined") return;

        const mq = window.matchMedia("(orientation: landscape)");
        const handler = (e) => setIsLandscape(e.matches);

        mq.addEventListener("change", handler);
        return () => mq.removeEventListener("change", handler);
    }, []);

    return { isLandscape };
};

/**
 * Componente MobileView
 */
export const MobileView = ({ children, renderWithFragment = false, ...props }) => {
    const { isMobile } = useDeviceType();
    if (!isMobile) return null;

    return renderWithFragment ? <>{children}</> : <div {...props}>{children}</div>;
};

/**
 * Componente BrowserView
 */
export const BrowserView = ({ children, renderWithFragment = false, ...props }) => {
    const { isBrowser } = useDeviceType();
    if (!isBrowser) return null;

    return renderWithFragment ? <>{children}</> : <div {...props}>{children}</div>;
};
